<template>
  <div class="relative mx-1 inline-flex items-center rounded-full bg-recommendation-base align-text-top icon-sm" />
</template>
